"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');



const gotoOrgTab = (orgKey, tabName) =>
  _store.history.push(_routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ORG_PAGE, { orgKey, tabName }))

// orgKey names the account by any of its orgs.
const gotoAccountTab = (orgKey, tabName) =>
  _store.history.push(_routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ACCOUNT_PAGE, { orgKey, tabName }))

// Account → People with that person's card open (F-9).
 const gotoAccountPerson = (orgKey, userKey) =>
  _store.history.push(`${_routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ACCOUNT_PAGE, { orgKey, tabName: 'people' })}?person=${encodeURIComponent(userKey)}`); exports.gotoAccountPerson = gotoAccountPerson

const gotoSettingsRoot = () => _store.history.push(_routes2.default.SETTINGS.ROOT)
const gotoOrgsList = () => _store.history.push(_routes2.default.SETTINGS.ORGS)

const gotoOrgInfo = (orgKey) => gotoOrgTab(orgKey, 'info')
const gotoOrgMembers = (orgKey) => gotoOrgTab(orgKey, 'members')
const gotoOrgMembership = (orgKey) => gotoOrgTab(orgKey, 'membership')
const gotoOrgSubscriptions = (orgKey) => gotoOrgTab(orgKey, 'plan')
const gotoAccountSettings = (orgKey) => gotoAccountTab(orgKey, 'settings')
const gotoOrgConsent = (orgKey) => gotoOrgTab(orgKey, 'consent')
const gotoOrgBranding = (orgKey) => gotoOrgTab(orgKey, 'branding')

 const useNav = () => ({
  gotoSettingsRoot,
  gotoOrgsList,
  gotoOrgInfo,
  gotoOrgMembers,
  gotoOrgMembership,
  gotoOrgSubscriptions,
  gotoAccountTab,
  gotoAccountSettings,
  gotoAccountPerson: exports.gotoAccountPerson,
  gotoOrgConsent,
  gotoOrgBranding,
}); exports.useNav = useNav
